import { useSwiftServerHealthCheck } from '../swift/useSwiftServerHealthcheck';
import useIsSwiftEnabledForUser from 'src/hooks/signedMsgOrders/useIsSwiftEnabledForUser';
import { useMarketEnabledForSignedMsgOrders } from 'src/hooks/signedMsgOrders/useMarketEnabledForSignedMsgOrders';
import { OracleSource } from '@velocity-exchange/sdk';
import { UIOrderType } from '@velocity-exchange/common';

interface Params {
	orderType: UIOrderType;
	marketOracle: OracleSource | undefined;
	postOnly?: boolean;
	marketIndex: number;
}

/**
 * Determines whether we should use Swift for the given trade considering the user's
 * Swift status along with the given trade parameters (e.g. order type, post only, etc.)
 */
export default function useIsSwiftEnabledForTrade({
	orderType,
	marketOracle,
	marketIndex,
	postOnly,
}: Params) {
	const isSwiftServerHealthy = useSwiftServerHealthCheck();
	const isSwiftEnabledForUser = useIsSwiftEnabledForUser();
	const isSwiftEnabledForMarket = useMarketEnabledForSignedMsgOrders(
		marketOracle,
		marketIndex
	);

	const isMarketOrLimit = orderType === 'market' || orderType === 'limit';

	return (
		!!isSwiftServerHealthy &&
		!!isSwiftEnabledForUser &&
		isSwiftEnabledForMarket &&
		isMarketOrLimit &&
		!postOnly
	);
}
